export const getDecorationArtworkChoices = (decoration = {}, supportsPromoStoreArtworkChoices = false) => {
  if (!supportsPromoStoreArtworkChoices) {
    return [decoration?.artwork || {}];
  }

  if (Array.isArray(decoration?.ArtWorks) && decoration.ArtWorks.length > 0) {
    return decoration.ArtWorks;
  }

  return [decoration?.artwork || decoration?.ArtWork || {}];
};

export const shouldShowInlineArtworkAddControl = (supportsPromoStoreArtworkChoices = false) =>
  supportsPromoStoreArtworkChoices === true;
